import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { ImprimirVisitaGrilla } from './components/ImprimirVisitaGrilla';

export default function ImprimirVisita() {
  return (
    <>
      <MainContent
        titulo='Gestión de Impresiones'
        component={<ImprimirVisitaGrilla />}
        tableMaxWidth
      />
      <Toaster />
      <Outlet />
    </>
  );
}